import React from 'react';

const reportErrors = C => {
  class Wrapped extends React.Component {
    static displayName = `reportErrors(${C.name || C.displayName})`;

    state = {
      error: false,
    };

    componentDidCatch(err) {
      console.error(err);
      this.setState({error: true});
    }

    render() {
      if (this.state.error) {
        return <div>Failed to load. Please refresh and try again.</div>;
      }

      return <C {...this.props} />;
    }
  }

  return Wrapped;
};


export default reportErrors;
